import {
  useGetExamByExamCardIdQuery as useGetExaminationInstruction,
  GetExamByExamCardIdQuery as ExaminationInstructionType,
  QbQuestionType,
} from '../../generated/graphql';

export default useGetExaminationInstruction;
export type { ExaminationInstructionType };
export { QbQuestionType };
